import { useMemo } from 'react';

import { PROFROLE_ID_DELIMITER } from 'utils/profRoles';

import {
    AdditionalDefault,
    createStaticDataProvider,
    DataProvider,
    fromTree,
    ModelData,
    StaticDataFetcherItem,
    TreeCollection,
} from '@hh.ru/magritte-ui';

import { ProfRoles, selectProfessions } from 'store/autoReducers';
import { useSelector } from 'store/utils';

const convertProfRolesToModelData = (profRoles: ProfRoles[]): ModelData[] => {
    return profRoles.map((category) => {
        const categoryId = `${category.id}${PROFROLE_ID_DELIMITER}`;
        const items = category.professionalRoles
            ? category.professionalRoles.map((role) => ({
                  id: String(role.id),
                  text: role.name,
                  items: undefined,
              }))
            : undefined;

        return {
            id: categoryId,
            text: category.name,
            items,
        };
    });
};

export const useData = (): {
    collection: TreeCollection<AdditionalDefault>;
    provider: DataProvider<StaticDataFetcherItem>;
} => {
    const items = useSelector(selectProfessions);

    return useMemo(() => {
        const modelData = convertProfRolesToModelData(items);
        const collection = fromTree<AdditionalDefault>(modelData);

        return {
            collection,
            provider: createStaticDataProvider(
                collection
                    .toList()
                    .filter((item) => collection.getParentId(item.id) !== undefined)
                    .map((item) => ({
                        value: item.id,
                        text: item.text,
                    }))
            ),
        };
    }, [items]);
};
